import { LoginBanner } from './login-banner';
import { LoginBannerApollo } from './login-banner-apollo';
import { LoginBannerIpl } from './login-banner-ipl';
import { LoginBannerWincanton } from './login-banner-wincanton';
import React from 'react';
import { Col } from 'react-bootstrap';
import { usePlatform } from 'src/business/context/platform-context';

export const LoginGenericBanner = (): React.ReactElement => {
	const { isEyeQMarketplace, isAtom, isIpl } = usePlatform();

	const renderBanner = (): React.ReactNode => {
		if (isEyeQMarketplace) return <LoginBannerWincanton />;
		if (isAtom) return <LoginBannerApollo />;
		if (isIpl) return <LoginBannerIpl />;
		return <LoginBanner />; // Default
	};

	return (
		<Col
			md={8}
			className="p-0 d-none d-sm-block"
		>
			{renderBanner()}
		</Col>
	);
};
